export default __webpack_public_path__ + "static/media/pin.8df689b5.png";